angular.module("multicrm")

.constant("ENV", "prod")

.constant("VERSION", "1.27.126")

;